import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

export type ShareResult = {
  success: boolean;
  contentId: string;
};

@Injectable({ providedIn: "root" })
export class ShareService {
  /**
   * Mock share call. In real implementation, this would POST to backend.
   */
  share(contentId: string): Observable<ShareResult> {
    return of({ success: true, contentId });
  }
}
